import { FaDownload, FaBarcode } from 'react-icons/fa';

const ScannedTicketsList = ({ scannedTickets, onOpenExport }) => (
  <div className="scanned-tickets">
    <div className="scanned-tickets-header">
      <h3>Recent Scans</h3>
      <button
        className="export-button"
        onClick={onOpenExport}
        disabled={scannedTickets.length === 0}
      >
        <FaDownload /> Export
      </button>
    </div>

    <div className="tickets-list">
      {scannedTickets.length > 0 ? (
        scannedTickets.map((ticket) => (
          <div key={ticket.id} className="ticket-item">
            <div className="ticket-code">
              <FaBarcode /> {ticket.code}
            </div>
            <div className="ticket-time">
              {new Date(ticket.timestamp).toLocaleTimeString()}
            </div>
          </div>
        ))
      ) : (
        <div className="no-tickets">
          <p>No tickets scanned yet</p>
        </div>
      )}
    </div>
  </div>
);

export default ScannedTicketsList;
